const Grid = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5537 8.38033H2.30216C2.00369 8.38033 1.71744 8.26177 1.50638 8.05071C1.29533 7.83966 1.17676 7.55341 1.17676 7.25493V3.0034C1.17676 2.70492 1.29533 2.41867 1.50638 2.20761C1.71744 1.99656 2.00369 1.87799 2.30216 1.87799H6.5537C6.85217 1.87799 7.13842 1.99656 7.34948 2.20761C7.56053 2.41867 7.6791 2.70492 7.6791 3.0034V7.25493C7.6791 7.55341 7.56053 7.83966 7.34948 8.05071C7.13842 8.26177 6.85217 8.38033 6.5537 8.38033V8.38033Z"
      fill="black"
    />
    <path
      d="M14.0552 8.38015H9.80363C9.50515 8.38015 9.2189 8.26158 9.00785 8.05053C8.79679 7.83947 8.67822 7.55322 8.67822 7.25475V3.00321C8.67822 2.70474 8.79679 2.41849 9.00785 2.20743C9.2189 1.99638 9.50515 1.87781 9.80363 1.87781H14.0552C14.3536 1.87781 14.6399 1.99638 14.8509 2.20743C15.062 2.41849 15.1806 2.70474 15.1806 3.00321V7.25475C15.1806 7.55322 15.062 7.83947 14.8509 8.05053C14.6399 8.26158 14.3536 8.38015 14.0552 8.38015V8.38015Z"
      fill="black"
    />
    <path
      d="M6.55345 15.8822H2.30192C2.00344 15.8822 1.71719 15.7636 1.50614 15.5525C1.29508 15.3415 1.17651 15.0552 1.17651 14.7568V10.5052C1.17651 10.2068 1.29508 9.9205 1.50614 9.70945C1.71719 9.49839 2.00344 9.37982 2.30192 9.37982H6.55345C6.85193 9.37982 7.13818 9.49839 7.34923 9.70945C7.56029 9.9205 7.67886 10.2068 7.67886 10.5052V14.7568C7.67886 15.0552 7.56029 15.3415 7.34923 15.5525C7.13818 15.7636 6.85193 15.8822 6.55345 15.8822V15.8822Z"
      fill="black"
    />
    <path
      d="M14.0552 15.8822H9.80363C9.50515 15.8822 9.2189 15.7636 9.00785 15.5525C8.79679 15.3415 8.67822 15.0552 8.67822 14.7568V10.5052C8.67822 10.2068 8.79679 9.9205 9.00785 9.70945C9.2189 9.49839 9.50515 9.37982 9.80363 9.37982H14.0552C14.3536 9.37982 14.6399 9.49839 14.8509 9.70945C15.062 9.9205 15.1806 10.2068 15.1806 10.5052V14.7568C15.1806 15.0552 15.062 15.3415 14.8509 15.5525C14.6399 15.7636 14.3536 15.8822 14.0552 15.8822V15.8822Z"
      fill="black"
    />
  </svg>
);

export default Grid;
